export const Loading = ({maxHeight}) => {
    return (
        <div style={{display: "flex", justifyContent: "center", alignContent: "center", height:maxHeight === false ? "" : "100vh"}}>
            <img
                src="https://d2jun3ty2bmcrf.cloudfront.net/website/img/login-loading.svg"
                alt="Loading"
                title="Loading"
                width="100"
            />
        </div>
    );
};
